import { sleep } from '../sleep'

type Options<T> = {
  maxRetry?: number
  when?: (response: T) => boolean
  delay?: number
  whenError?: (error: T) => boolean
}

export const retryWhen = <Fn extends (...args: any[]) => Promise<any>>(
  fn: Fn,
  { maxRetry = 3, when = () => false, delay = 1000, whenError = () => false }: Options<Awaited<ReturnType<Fn>>>
) => {
  const retry = async (count: number, ...args: Parameters<Fn>): Promise<Awaited<ReturnType<Fn>>> => {
    count++
    const maxFlag = maxRetry <= count
    try {
      const response = await fn(...args)
      if (!when(response) || maxFlag) {
        return response
      } else {
        await sleep(delay / 1000)
        if (count < maxRetry) return retry(count + 1, ...args)
        else return response
      }
    } catch (error) {
      if (!whenError(error) || maxFlag) {
        throw error
      } else {
        await new Promise((resolve) => setTimeout(resolve, delay))
        return retry(count + 1, ...args)
      }
    }
  }

  return (...args: Parameters<Fn>) => retry(0, ...args)
}
